import { createSlice } from '@reduxjs/toolkit';
import LocalStorageService from '../services/localstorage.service';
import { buildChatObject, buildIncomingMessage, buildResponseMessage, getUnseenMsgCount } from '../components/digital/chatUtil';

const initialState = {
    unansweredChats: {},
    answeredChats: {},
    chatWrapUpTimeRedux: 0,
    activeSessionId: LocalStorageService.getItem('chatSessionId') !== null && LocalStorageService.getItem("chatSessionId") === "null" ? null : LocalStorageService.getItem('chatSessionId'),
    isChatActive: false,
    suggestedChat: "",
    chatScreenPops: [],
    chatDisposition: [],
    isEmailEnabled: false,
    chatType: '',
    emailData: null,
    emailBody: null,
    replayMailEnabled: false,
    firstSessions: {},
    declinedChatsMonitorUcids: (LocalStorageService.getObject("declinedChatsMonitorUcids") !== null && LocalStorageService.getObject("declinedChatsMonitorUcids") !== undefined && LocalStorageService.getObject("declinedChatsMonitorUcids") !== "null" && LocalStorageService.getObject("declinedChatsMonitorUcids") !== "undefined") ? LocalStorageService.getObject("declinedChatsMonitorUcids") : [],
    pauseAfterSession: false,
    pauseAfterSessionReason: null,
    showPauseTimeExceededLabel: false,
    showPauseAfterSessionTime: false,
    showExceededTime: false,
    isChatQueueOpen: false,
    agentSubUserLatestMsg: '',
    interactionHubAgentAssistActiveTab: '',
    chatSuggestionList: [],
    chatSuggestionLoading: false,
    parkingApiCallCount : 0
};

export const digitalSlice = createSlice({
    name: 'digital',
    initialState,
    reducers: {
        handleIncommingMsgs: (state, action) => {    // for handling incomming msg,
            if (state.answeredChats[action.payload.chatCustSessionId]) {
                state.answeredChats[action.payload.chatCustSessionId].unSeenMsgCount = getUnseenMsgCount(action.payload.chatCustSessionId, state.answeredChats[action.payload.chatCustSessionId], state.activeSessionId)
                state.answeredChats[action.payload.chatCustSessionId].currentChat.push(buildIncomingMessage(action.payload))
            }
        },
        acceptNewChat: (state, action) => {  // moving obj from unanswerd list to answered list
            if (state.unansweredChats[action.payload]) {
                delete state.unansweredChats[action.payload];
            }
        },
        updateAgentConversation: (state, action) => {       // constructing msg obj, if agent send msg 
            state.answeredChats[action.payload.chatCustSessionId].currentChat.push(buildResponseMessage(action.payload))
        },

        handleNewAcceptedChatRequest: (state, action) => {  // chatonmulti (web socket event), if this web socket triggered, we are directly adding the chat to answered list and making it as active chat 
            let newChat = buildChatObject(action.payload);
            if (!Object.values(state.answeredChats).length > 0 && state.activeSessionId === null) {
                state.activeSessionId = newChat.chatCustSessionId;
                state.answeredChats[newChat.chatCustSessionId] = newChat;
            }
            state.answeredChats[newChat.chatCustSessionId] = newChat;
            state.isChatActive = true
        },
        handleChatEndedByCustomer: (state, action) => {  // for handling if customer ended the chat 
            if (state.answeredChats[action.payload.chatCustSessionId]) {
                state.answeredChats[action.payload.chatCustSessionId].chatDetails.customerEnded = true;
            }
            if (state.unansweredChats[action.payload.chatCustSessionId]) {
                delete state.unansweredChats[action.payload.chatCustSessionId]
            }
        },
        handleChatDecline: (state, action) => {
            delete state.unansweredChats[action.payload.sessionId]
        },
        handleActiveSessionId: (state, action) => {
            if (action.payload && state.answeredChats[action.payload]) {
                state.answeredChats[action.payload].unSeenMsgCount = 0;
            }
            state.activeSessionId = action.payload
        },
        handleChatRemove: (state, action) => {
            if (state.answeredChats[action.payload.chatCustSessionId]) {
                delete state.answeredChats[action.payload.chatCustSessionId]
                delete state.firstSessions[action.payload.chatCustSessionId];
            }
            if (Object.values(state.answeredChats).length > 0) {
                state.activeSessionId = Object.values(state.answeredChats)[0]?.chatCustSessionId;
                state.chatType = Object.values(state.answeredChats)[0]?.chatDetails.channelType;
            }
            else {
                state.activeSessionId = null
                state.isChatActive = false
            }
        },
        handleChatAcceptStatus: (state, action) => {
            state.isChatActive = action.payload
        },
        // new chats handling
        handleNewIncomingChatRequest: (state, action) => {   //  incomingChat (web socket event)    if this web socket triggered, we are adding chat to unAnswered chats list 
            let newChat = buildChatObject(action.payload)
            state.unansweredChats[newChat.chatCustSessionId] = newChat;
        },
        updateTemplateValues: (state, action) => {
            if (state.answeredChats[action.payload.sessionId]) {
                state.answeredChats[action.payload.sessionId].templateData = action.payload.templateData;
                state.answeredChats[action.payload.sessionId].templateMsg = action.payload.templateMsg;
            }
        },
        handleTemplateFieldUpdate: (state, action) => {
            state.answeredChats[action.payload.sessionId].templateData[action.payload.index].value = action.payload.value
        },
        handleReloadState: (state, action) => {
            if (Object.values(state.answeredChats).length > 0) {
                state.activeSessionId = Object.values(state.answeredChats)[0].chatCustSessionId
            }
            else {
                state.activeSessionId = null
            }
            state.isChatActive = LocalStorageService.getItem("isChatActive") === 'true';
        },
        handleInputMessage: (state, action) => {
            state.answeredChats[action.payload.sessionId].inputMessage = action.payload.inputMessage;
        },
        updateIsAgentFirstReplay: (state, action) => {
            state.answeredChats[action.payload.sessionId].isFirstReply = action.payload.value;
            state.firstSessions[action.payload.sessionId] = !state.firstSessions.hasOwnProperty(action.payload.sessionId);
        },
        handleChatDetailsEnable: (state, action) => {
            state.answeredChats[action.payload.sessionId].showChatDetails = action.payload.showChatDetails
        },
        handleIsChatTemplateEnabled: (state, action) => {
            state.answeredChats[action.payload.sessionId].isChatTemplateEnabled = action.payload.isChatTemplateEnabled
        },
        handleChatTempDetailsSave: (state, action) => {
            state.answeredChats[action.payload.sessionId].showTempDetails = action.payload.showTempDetails
        },
        setChatSearch: (state, action) => {
            state.answeredChats[action.payload.sessionId].chatSearch = action.payload.chatSearch
        },
        onRefreshSetAnsweredChats: (state, action) => {
            state.answeredChats = action.payload
        },
        handleDeleteChats: (state, action) => {
            state.answeredChats = {};
            state.unansweredChats = {};
            state.activeSessionId = null;
            state.isChatActive = false;
        }
        ,
        setSuggestedValue: (state, action) => {
            state.suggestedChat = action.payload
        },
        refreshChat: (state, action) => {
            let activeChat = state.answeredChats[state.activeSessionId]
            if (activeChat.refresh === undefined) {
                activeChat = { ...activeChat, refresh: true }
            } else {
                activeChat.refresh = !activeChat.refresh
            }
            state.answeredChats[state.activeSessionId] = activeChat
        },
        setChatScreenpops: (state, action) => {
            state.chatScreenPops = action.payload
        },
        addChatDisposition: (state, action) => {
            state.chatDisposition.push(action.payload)
        },
        removeChatDisposition: (state, action) => {
            state.chatDisposition = action.payload;
        },
        clearChatDisposition: (state, action) => {
            state.chatDisposition = [];
        },
        resetDigitalSlice: (state, action) => {
            return initialState;
        },
        setEmaIlVisibility: (state, action) => {
            state.isEmailEnabled = action.payload
        },
        setDigitalChatChannelType: (state, action) => {
            state.chatType = action.payload
        },
        setEmailData: (state, action) => {
            const { activeSessionId, type, value } = action.payload;
            if (!state.answeredChats[activeSessionId]) return;
            const session = state.answeredChats[activeSessionId];
            if (type === 'emailData') {
                session.emailData = value;
            } else if (type === 'emailInfo') {
                // Merge values (offset, limit, etc.) into the existing emailInfo object
                session.emailInfo = {
                    ...(session.emailInfo || {}),
                    ...value
                };
            }
            if (session.emailReply?.emailData?.conversation) {
                const conversation = session.emailReply.emailData.conversation;
                switch (type) {
                    case 'from': conversation.from = value; break;
                    case 'to': conversation.to = value; break;
                    case 'cc': conversation.cc = value; break;
                    case 'bcc': conversation.bcc = value; break;
                    case 'subject': conversation.subject = value; break;
                    case 'send_at': conversation.send_at = value; break;
                    case 'file_ids': conversation.file_ids = value; break;
                    case 'body': conversation.data = value; break; // Body of the email
                    default:
                        console.warn(`Unhandled conversation update type: ${type}`);
                        break;
                }
            }
            if (type === "replayMail") {
                session.replayMailEnabled = value;
            }
            if (type === "emailBody") {
                session.emailBody = value;
            }
        },
        setFirstSessions: (state, action) => {
            state.firstSessions[action.payload] = !state.firstSessions.hasOwnProperty(action.payload);
        },
        addDeclinedChatsMonitorUcids: (state, action) => {
            state.declinedChatsMonitorUcids.push(action.payload)
        },
        pauseAfterSession: (state, action) => {
            if (action.payload.type) {
                state.pauseAfterSession = action.payload.type
            }
            else {
                state.pauseAfterSession = false
            }
            if (action.payload.reason) {
                state.pauseAfterSessionReason = action.payload.reason
            }
        },
        pauseTimeExceeded: (state, action) => {
            if (action.payload) {
                state.showPauseTimeExceededLabel = action.payload
            }
            else {
                state.showPauseTimeExceededLabel = action.payload
            }
        },
        showPauseAfterSessionTime: (state, action) => {
            if (action.payload) {
                state.showPauseAfterSessionTime = action.payload
            }
            else {
                state.showPauseAfterSessionTime = action.payload
            }
        },
        showExceededTimelimit: (state, action) => {
            if (action.payload) {
                state.showExceededTime = action.payload
            }
            else {
                state.showExceededTime = action.payload
            }
        },
        setChatWrapUpTime: (state, action) => {
            state.chatWrapUpTimeRedux = action.payload;
        },
        handlePullChatsDialog: (state, action) => {
            state.isChatQueueOpen = action.payload;
        },
        handleAgentSubUserChat: (state, action) => {
            state.agentSubUserLatestMsg = action.payload;
        },
        setInterationHubAgentAssistTab: (state, action) => {
            state.interactionHubAgentAssistActiveTab = action.payload;
        },
        setChatSuggestionList: (state, action) => {
            state.chatSuggestionList = action.payload;
        },
        setChatSuggestionLoading: (state, action) => {
            state.chatSuggestionLoading = action.payload;
        }, 
        setChatParkingApiCount: (state, action) => {
            state.parkingApiCallCount = action.payload;
        },
        updateEmailConversation: (state, action) => {
            const chat = state.answeredChats[action.payload.chatCustSessionId];
            state.answeredChats[action.payload.chatCustSessionId].unSeenMsgCount = getUnseenMsgCount(action.payload.chatCustSessionId, state.answeredChats[action.payload.chatCustSessionId], state.activeSessionId)
            if (chat?.emailInfo?.conversation) {
                chat.emailInfo.conversation.unshift(action.payload);
            } else {
                console.warn("Could not update conversation: path does not exist", action.payload.chatCustSessionId);
            }
        }
    }
})
export const { updateEmailConversation,setChatParkingApiCount,handleIsChatTemplateEnabled, handleChatTempDetailsSave, setChatSuggestionLoading, setChatSuggestionList, setInterationHubAgentAssistTab, handleAgentSubUserChat, setChatSearch, handlePullChatsDialog, showExceededTimelimit, setChatWrapUpTime, pauseTimeExceeded, showPauseAfterSessionTime, pauseAfterSession, setFirstSessions, onRefreshSetAnsweredChats, updateIsAgentFirstReplay, setEmailData, setDigitalChatChannelType, setEmaIlVisibility, setChatScreenpops, resetDigitalSlice, handleDeleteChats, handleChatDetailsEnable, handleInputMessage, setSuggestedValue, handleReloadState, handleTemplateFieldUpdate, updateTemplateValues, handleCustMediaMsg, handleNewIncomingChatRequest, handleChatAcceptStatus, handleActiveSessionId, handleChatRemove, handleChatDecline, handleIncommingMsgs, acceptNewChat, updateMsgSeenStatus, updateAgentConversation, handleNewAcceptedChatRequest, handleChatEndedByCustomer, refreshChat, addChatDisposition, removeChatDisposition, clearChatDisposition, addDeclinedChatsMonitorUcids } = digitalSlice.actions;
export default digitalSlice.reducer;